
/*RELEASE URLS */
const userApiURL = `https://user.customer.artsmrkts.${window.location.hostname.split('.').reverse()[0]}/api`;
const paymentApiURL = `https://payment.customer.artsmrkts.${window.location.hostname.split('.').reverse()[0]}/api`;

/* DEBUG URLS*/
const userApiURLDebug = 'https://localhost:5001/api';
const paymentApiURLDebug = 'https://localhost:5003/api';
//const userApiURLDebug = 'https://user.customer.artsmrkts.com/api';
//const paymentApiURLDebug = 'https://payment.customer.artsmrkts.com/api';
var isUnminified = /param/.test(function (param) { });

/*Define debug variable for services urls  */
const debug = isUnminified;

const userService = (url) => (debug ? userApiURLDebug.concat(url) : userApiURL.concat(url));
const paymentService = (url) => (debug ? paymentApiURLDebug.concat(url) : paymentApiURL.concat(url));


export const Config = {
    appSettings: {
        defaultLanguage: 'en',
        defaultLanguageFile: require('../assets/lang/en'),
        debug: debug
    },
    service: {
        /** 
         * [USER] 
        */
        user: {
            login: userService('/user/login'),
            authenticated: userService('/user/authenticated'),
            account: {
                detail: userService('/user/accountdetail'),
                list: userService('/user/accountlist'),
                all: userService('/user/accountall'),
                history: userService('/user/accounthistory')
            },
            bankAccounts: userService('/user/bankaccounts'),
            customerBankAccountList: userService('/user/customerbankaccountlist'),
            customerBankAccountAdd: userService('/user/CustomerBankAccountAdd'),
            campaigns: userService('/user/Campaigns'),
            addressWhiteList: userService('/user/whiteList'),
            addAddressWhiteList: userService('/user/AddAddressWhiteList'),
        },
        /** 
         * [DEPOSIT] 
        */
        deposit: {
            FastPay: paymentService('/deposit/fastpay'),
            Neteller: paymentService('/deposit/neteller'),
            Skrill: paymentService('/deposit/skrill'),
            CreditCard: paymentService('/deposit/creditcard'),
            CommunityBank: paymentService('/deposit/communitybank'),
            QrCode: paymentService('/deposit/qrcode'),
            flashPay: paymentService('/deposit/flashpay'),
            flashPayDepositToKointra: paymentService('/deposit/deposittokointra'),
            cancelDepositOnKointra: paymentService('/deposit/canceldepositonkointra'),
            ZotaPay: paymentService('/deposit/zotapay'),
            ZotaPayQrCode: paymentService('/deposit/zotapayqrcode'),
            Unipayment: paymentService('/deposit/unipayment'),
            detail: userService('/personnel/deposit/detail'),
            getRefundInvoices: userService('/deposit/unipayment/invoice/refund')
        },
        /** 
         * [WITHDRAWAL] 
        */
        withdrawal: {
            Neteller: paymentService('/withdrawal/neteller'),
            Skrill: paymentService('/withdrawal/skrill'),
            BtcPay: paymentService('/withdrawal/btcpay'),
            TPay: paymentService('/withdrawal/tpay'),
            TPayTRC20: paymentService('/withdrawal/tpaytrc20'),
            FlashPay: paymentService('/withdrawal/flashpay'),
            UnionPay: paymentService('/withdrawal/unionpay'),
            BankAccount: paymentService('/withdrawal/bankaccount'),
            ZotaPay: paymentService('/withdrawal/zotapay'),
            Unipayment: paymentService('/withdrawal/unipayment'),
            Cancel: paymentService('/withdrawal/cancel'),
            Verification: paymentService('/withdrawal/verification')
        },
        /** 
         * [INTERNAL_TRANSFER] 
        */
        internalTransfer: {
            Create: paymentService('/internaltransfer/create')
        },
        /** 
         * [PAYMENT] 
        */
        payment: {
            deposit: {
                CommunityBank: {
                    BankList: paymentService('/payment/communitybanklist'),
                    AmountList: paymentService('/payment/communitybankamount'),
                },
                BtcPay: paymentService('/payment/btcpaydeposit'),
                TPay: paymentService('/payment/TPayDeposit'),
                TPayTRC20Pay: paymentService('/payment/TPayTRC20Deposit'),
                Unipayment: {
                    getInvoices: paymentService('/payment/unipayment/invoices'),
                    getInvoice: paymentService('/payment/unipayment/invoice'),
                }

            },
            withdrawal: {
                NetellerAccount: paymentService('/payment/netelleraccount'),
                SkrillAccount: paymentService('/payment/skrillaccount')
            },
            price: paymentService('/payment/price'),
            coinPrice: paymentService('/payment/coinprice'),
        },
        /** 
        * [FLASHPAY] 
       */
        flashPay: {
            withdrawal: {
                hasAccount: userService('/withdrawal/flashpay'),
                login: userService('/withdrawal/flashpaylogin'),
                register: userService('/withdrawal/flashpayregister'),
            },
            deposit: {
                hasAccount: userService('/deposit/flashpay'),
                login: userService('/deposit/flashpaylogin'),
                register: userService('/deposit/flashpayregister'),
            }
        },
        erc20: {
            deposit: {
                Tpay: paymentService('/deposit/tpay')
            }
        },
        trc20: {
            deposit: {
                Tpay: paymentService('/deposit/tpaytrc20')
            }
        },
        /** 
         * [TRANSFER_OPTION] 
        */
        transferOption: {
            deposit: {
                page: userService('/deposit/page'),
                history: userService('/deposit/history'),
                options: userService('/deposit/options'),
                optionPage: userService('/deposit/optionpage')
            },
            withdrawal: {
                page: userService('/withdrawal/page'),
                history: userService('/withdrawal/history'),
                options: userService('/withdrawal/options'),
                optionPage: userService('/withdrawal/optionpage')
            },
            internalTransfer: {
                page: userService('/internalTransfer/page'),
                settings: userService('/internalTransfer/settings'),
                history: userService('/internalTransfer/history')
            }
        },
        /** 
         * [RESEARCH] 
        */
        research: {
            dailyTechnicalView: userService('/research/dailytechnicalview'),
            weekAhead: userService('/research/weekahead'),
            webinar: userService('/research/webinar'),
            focus: userService('/research/focus')
        },
        /** 
       * [DOCUMENT] 
      */
        document: {
            upload: userService('/document/uploadfile'),
            getDocument: userService('/document/documents'),
            documentKey: userService('/document/key')
        },
        /** 
        * [DOCUMENT] 
        */
        bonus: {
            apply: paymentService('/bonus/applybonuscampaign')
        }

    },
    languageList: [
        {
            key: 'tr',
            icon: 'tr-flag.svg',
            text: 'Turkish'
        },
        {
            key: 'en',
            icon: 'uk-flag.svg',
            text: 'English'

        },
        {
            key: 'cn',
            icon: 'cn-flag.svg',
            text: 'Chinese'
        },
        {
            key: 'th',
            icon: 'th-flag.svg',
            text: 'Thai'
        }
    ]

}

export const AuthHeader = () => {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.token) {
        return { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + user.token };
    } else {
        return { 'Content-Type': 'application/json' };
    }
}

export const GetUserToken = () => {
    return JSON.parse(localStorage.getItem('user')).token
}